import { apiFetch, assetUrl } from "../utils/api";

export { assetUrl };

export async function shopGet(path) {
  const res = await apiFetch(`/api/shop/v1${path}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof data.detail === "string" ? data.detail : "请求失败");
  }
  return data;
}

export async function shopPost(path, body) {
  const res = await apiFetch(`/api/shop/v1${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof data.detail === "string" ? data.detail : "请求失败");
  }
  return data;
}

export async function shopPut(path, body) {
  const res = await apiFetch(`/api/shop/v1${path}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof data.detail === "string" ? data.detail : "请求失败");
  }
  return data;
}

export async function shopDelete(path) {
  const res = await apiFetch(`/api/shop/v1${path}`, { method: "DELETE" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof data.detail === "string" ? data.detail : "请求失败");
  }
  return data;
}

export function productImage(url) {
  return assetUrl(url) || "https://via.placeholder.com/400x400?text=好物";
}

export function formatPrice(v) {
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return `¥${n.toFixed(2)}`;
}
